import styled, { css } from "styled-components";
import { Form } from "react-bootstrap";
import { InputBaseStyles } from "../basestyles.jsx";

export const StyledTextArea = styled(Form.Control).attrs({
  className: "form-control",
})`
  ${InputBaseStyles};
  width: 100%;
  height: auto !important;
  border-top: 0;
  border-left: 0;
  border-right: 0;
  background-size: 12px 6px;
  padding: 1.5rem 1rem 0.5rem 1rem !important;
  min-height: auto !important;

  ${(props) =>
    props.$active &&
    css`
      color: rgba(0, 58, 120, 1);
      background-color: rgba(230, 243, 254, 1);
    `};
`;
